const tones = [
    { frequency: 784, startOffset: 0 },
    { frequency: 1047, startOffset: 0.11 },
];

const toneAttackSeconds = 0.012;
const toneReleaseSeconds = 0.32;
const toneTailSeconds = 0.36;
const silentGain = 0.0001;
const peakGain = 0.16;

// o mesmo evento chega por dois caminhos (aviso posicional e reordenação da agenda):
// sem a janela, uma troca de topo tocaria dois sons em sequência
const minimumIntervalMs = 1500;

let audioContext = null;
let gestureListenersAttached = false;
let lastPlayedAt = 0;

const getAudioContextConstructor = () =>
    window.AudioContext || window.webkitAudioContext;

const getAudioContext = () => {

    if (audioContext)
        return audioContext;

    const AudioContextConstructor = getAudioContextConstructor();
    if (!AudioContextConstructor)
        return null;

    audioContext = new AudioContextConstructor();
    return audioContext;
}

const scheduleTone = (context, { frequency, startOffset }, startedAt) => {

    const oscillator = context.createOscillator();
    const gain = context.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    oscillator.connect(gain);
    gain.connect(context.destination);

    const startsAt = startedAt + startOffset;

    gain.gain.setValueAtTime(silentGain, startsAt);
    gain.gain.exponentialRampToValueAtTime(peakGain, startsAt + toneAttackSeconds);
    gain.gain.exponentialRampToValueAtTime(silentGain, startsAt + toneReleaseSeconds);

    oscillator.start(startsAt);
    oscillator.stop(startsAt + toneTailSeconds);
}

const play = () => {

    try {
        const context = getAudioContext();
        if (!context)
            return;

        if (context.state === 'suspended') {
            context.resume();
            return;
        }

        const now = Date.now();
        if (now - lastPlayedAt < minimumIntervalMs)
            return;

        lastPlayedAt = now;

        const startedAt = context.currentTime;
        tones.forEach(tone => scheduleTone(context, tone, startedAt));

    } catch (error) {
        console.error(error);
    }
}

const primeOnFirstGesture = () => {

    if (gestureListenersAttached || !getAudioContextConstructor())
        return () => { };

    gestureListenersAttached = true;

    const prime = () => {
        detach();

        const context = getAudioContext();
        if (context?.state === 'suspended')
            context.resume();
    }

    const detach = () => {
        gestureListenersAttached = false;
        document.removeEventListener('pointerdown', prime);
        document.removeEventListener('keydown', prime);
    }

    document.addEventListener('pointerdown', prime);
    document.addEventListener('keydown', prime);

    return detach;
}

export default {
    play,
    primeOnFirstGesture,
}
